import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';
import { v4 } from 'uuid';

import { toDto as toReservationDto } from '../../../models/adapters/ReservationAdapter';
import { getTableState, modifyState } from '../../../utils/reservation';
import {
  reservationStateUpdated,
  reservationStateUpdateFailed,
  updateReservationState,
  UpdateReservationStatePayload,
} from '../../actions/reservation/updateReservationState';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* updateReservationStateSaga({ payload }: Action<UpdateReservationStatePayload>) {
  const { reservation, newState, datetime } = payload;
  const { uuid: reservationUuid } = reservation;
  const currentState = getTableState(reservation, datetime);
  const updatedReservation = modifyState(reservation, currentState, newState, datetime);
  const reservationDto = toReservationDto(updatedReservation);
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updateReservation, token, { reservationDto });
  const { error } = response;
  const timestamp = moment();
  const announcement = { uuid: v4(), timestamp, referenceId: reservation.uuid };
  if (!error) {
    const responsePayload = { reservation: updatedReservation, reservationUuid, announcement, timestamp };
    yield put(reservationStateUpdated(responsePayload));
  } else {
    yield put(reservationStateUpdateFailed({ reservationUuid, timestamp }));
  }
}

export default function* watchUpdateReservationStateSaga() {
  yield takeEvery(updateReservationState, updateReservationStateSaga);
}
